import styled from 'styled-components';
import { GlobalToken } from 'antd';

import { EPCollapse } from '@/comp';

const { EPPanel } = EPCollapse;

export const ShowInDeviceStatusContainer = styled.div<{ theme: { token: GlobalToken } }>`
  .horizontal-line {
    height: 1px;
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    margin: ${({ theme: { token } }) => `${token.marginSM}px 0 ${token.marginMD}px 0`};
  }

  .show-in-device-status-checkbox {
    opacity: 0.6;
  }
`;

export const StationCollapsibleEPPanel = styled(EPPanel)`
  .metric-container {
    display: flex;
    align-items: center;

    .info-icon {
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }
`;

export const TierProtectionPanel = styled(EPPanel)<{ $shouldRestrictInvestigationDashboard?: boolean }>`
  ${({ $shouldRestrictInvestigationDashboard }) => $shouldRestrictInvestigationDashboard && 'opacity: 30%'};

  .metric-container {
    display: flex;
    align-items: center;

    .info-icon {
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }

  .tier-plus-icon {
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    margin-top: -${({ theme: { token } }) => token.marginXXS}px;

    &:hover {
      cursor: pointer;
    }
  }
`;
